import gql from 'graphql-tag';
import {useMutation} from '@apollo/client';

const MUTATION = gql`
  mutation submitPersonalInformationRequest($request: PersonalInformationRequest!) {
    submitPersonalInformationRequest(request: $request) {
      statusCode
      message
    }
  }
`;

export interface PersonalInformationRequest {
  requestType: string
  firstName: string
  lastName: string
  address1: string
  address2: string
  country: string
  city: string
  state: string
  zipCode: string
  email: string
  phone: string
  vinNumber: string
}

export interface PersonalInformationResponse {
  statusCode: number;
  message: string;
}

const useSubmitPersonalInformationRequest = (onCompleted = (_response: any) => {
}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (request: PersonalInformationRequest) => {
    return action({ variables: { request } });
  };
};

export default useSubmitPersonalInformationRequest;
